
import { Chip } from "@mui/material";
import {
    useTheme,
    Theme,
} from "@mui/material/styles";

import { determineConfig } from "../../utils/GetContext";

import EditIcon from '@mui/icons-material/Edit';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';


export function GetStatusBadge(props:{status:string,codes:any}){
    let ret = GetStatusIcon(props.status)
    const theme = useTheme();
    
    if(ret){
        return (
            <Chip
                style={{color:ret.color, backgroundColor:theme.palette.background.default}}
                label={determineConfig(props.codes,"vp_req_status",props.status) || props.status}
                icon={ret.icon}
                variant="filled"
                clickable={false}
                size="small"
            /> 
        )
    } else {
        return <div/>
    }
}

export function GetStatusIcon(status:string){
    const theme = useTheme();

    let ret:{
      color:string
      icon:JSX.Element
    }|undefined

    if(["VP_DRAFT","VP_QUEUE","VP_REQUST"].findIndex(v=>v===status)>=0){ // pending user edit/approve 
        ret = {
            color:theme.palette.statusBlue.main,
            icon:<EditIcon style={{color:theme.palette.statusBlue.main}}/>,
        }
    }
    if(["VP_REJECT","C","!","Z"].findIndex(v=>v===status)>=0){ // canceled  
        ret = {
            color:theme.palette.statusRed.main,
            icon:<CancelIcon style={{color:theme.palette.statusRed.main}}/>,
        }
    }
    if(["VP_ACCEPT"].findIndex(v=>v===status)>=0){ // accepted 
        ret = {
            color:theme.palette.statusBlue.main,
            icon:<AccountCircleIcon style={{color:theme.palette.statusBlue.main}}/>,
        }
    }
    if(["VP_SUBMIT","O"].findIndex(v=>v===status)>=0){ // sent to SAP 
        ret = {
            color:theme.palette.statusBlue.main,
            icon:<DoneIcon style={{color:theme.palette.statusBlue.main}}/>,
        }
    }
    if(["I","M"].findIndex(v=>v===status)>=0){ // being worked 
        ret = {
            color:theme.palette.statusBlue.main,
            icon:<PhoneAndroidIcon style={{color:theme.palette.statusBlue.main}}/>,
        }
    }
    if(["S","Y","VP_AS_IS"].findIndex(v=>v===status)>=0){ // complete 
        ret = {
            color:theme.palette.statusGreen.main,
            icon:<CheckCircleIcon style={{color:theme.palette.statusGreen.main}}/>,
        }
    }

    return ret
  }